import src from "./forbes.svg";
export default { src: src, aspect: 3.8461538461538463, width: 100, height: 26 };